export const rock = [
    {title: 'Instance crush ft julian_casablancas', src: 'https://dl.dropbox.com/s/bqyn9fh42ajgkne/05._instant_crush_feat._julian_casablancas.mp3'},
    {title: 'Maneskin', src: 'https://dl.dropbox.com/s/yhd9aqkeq54z2zi/M%C3%A5neskin%20-%20FEEL.mp3'},
    {title: 'Stay awake', src: 'https://dl.dropbox.com/s/esp1wsp4uv7nsjg/Stay%20Awake%20%28%40Mezzrrab%29.mp3'},
    {title: 'Mama said', src: 'https://dl.dropbox.com/s/bgsk01wky54r4ca/Metallica%20%E2%80%93%20Mama%20Said.mp3'},
]
export const RandB = [
    {title: 'How doese it feel?', src: 'https://dl.dropbox.com/s/0ega9h0i8nkzfqj/Chle-Ft-Chris-Brown-How-Does-It-Feel-24Naijamuzic-com.mp3'},
    {title: 'Talkback?', src: 'https://dl.dropbox.com/s/k6k49jogjbigjib/6LACK%20-%20Talkback.flac'},
    {title: 'Dont they', src: 'https://dl.dropbox.com/s/ovba8ndjoeb93mg/Josh%20Levi%20-%20DON%20T%20THEY%20%28REMIX%29%20%5Bfeat.%20Normani%5D.mp3'}
]
export const rap = [
    {title: 'Fumez', src: 'https://dl.dropbox.com/s/z8hposy5rr42f07/Fumez.mp3'},
    {title: 'Dasta', src: 'https://dl.dropbox.com/s/2kdvw7f6penbn7q/Dasta%20-%20Asadi%20%20Dsharp%20%20Erfan%20%28320%29.mp3'},
    {title: 'Bazigar', src: 'https://dl.dropbox.com/s/sgszpd882s2i62w/Koorosh%20%26%20The%20Don%20%26%20Sami%20Low%20-%20Bazigar%20%28NORMAL%29.ogg'},
    {title: 'Venom', src: 'https://dl.dropbox.com/s/gyjvaf46gcgu0hc/Eminem%20-%20Venom%20%28Music%20From%20The%20Motion%20Picture%29.mp3'}
]
export const iranian = [
    {title: 'Hoshyar kasi bayad', src: 'https://dl.dropbox.com/s/tal1ums8maoddw3/%C3%93lafur%20Arnalds%20%26%20Shajarian%20Mash.mp3'},
    {title: 'Ashke Mahtab', src: 'https://dl.dropbox.com/s/3jfjmw1mflxy56v/Ashke%20Mahtab%20%28%40Mezzrrab%29.mp3'},
    {title: 'Soghati', src: 'https://dl.dropbox.com/s/c79qe1ach9a7ixs/Hayedeh-Soghati-256.mp3'},
    {title: 'Bibi gol', src: 'https://dl.dropbox.com/s/3fws3qpp2zs7r9s/Bibi%20Gol%201.mp3'},
    {title: 'Kabeh', src: 'https://dl.dropbox.com/s/563r7j56f8a40k9/Moein%20Kabeh.mp3'},
]